import { render, staticRenderFns } from "./invoice_record.vue?vue&type=template&id=bec562be&scoped=true&"
import script from "./invoice_record.vue?vue&type=script&lang=js&"
export * from "./invoice_record.vue?vue&type=script&lang=js&"
import style0 from "./invoice_record.vue?vue&type=style&index=0&id=bec562be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec562be",
  null
  
)

export default component.exports